import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/transportation-to-work.png'

const DemographicsTransportation = dynamic(() => import('src/components/insights/demographics/cards/transportation'), {
  ssr: false,
})

export const DemographicsTransportationWidget: InsightBuilderWidget = {
  id: 'transportation-to-work',
  name: 'Transportation To Work',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsTransportation,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
